@mixin msg-elm {
  display: block;
  color: var(--s-color-text-default);
  text-align: left;
  font-weight: 300;
  line-height: var(--p-size-dynamic-300);
}

/**
  * @prop --quantity-input-width: Sets the width of the input field
  * @prop --quantity-input-max-width: Sets the max width of the input field
  */
:host {
  --quantity-input-max-width: 328px;

  /** @prop --quantity-input-width: Set the width of the <anchor-quantity> input */
  --quantity-input-width: 100%;

  display: block;
  max-width: var(--quantity-input-max-width);
}

.anchor-c-quantity {
  $quantity: &; // Storing 'anchor-c-quantity' as variable called $input to be used as a shorthand

  --input-field-padding-left: 0px;
  --input-field-padding-right: 0px;

  width: var(--quantity-input-width);

  display: flex;
  flex-direction: column;
  gap: var(--p-size-static-100);

  &.error {
    border-left: var(--p-size-static-050) var(--s-color-border-error) solid;
    padding-left: var(--p-size-static-200);
  }

  > anchor-label {
    display: inline-block;
  }

  anchor-input {
    --input-field-width: var(--p-size-static-800);
    --input-field-border-color-hover: none;
    --input-field-border-color-focus: none;
    --input-field-padding-right: 0;
    --input-field-padding-left: 0;
    --input-field-text-align: center;
  }

  anchor-icon-button {
    &.clicked {
      background-color: var(--color-background-brand);
      button {
        color: var(--color-text-on);
      }
    }

    button {
      --icon-button-border-radius: 0px;
    }
  }

  &__container {
    display: flex;
    align-items: stretch;
    gap: var(--p-size-static-200);
    border:1px solid transparent;
  }

  &__help-msg {
    @include msg-elm();
  }

  &__error-msg {
    display: flex;
    gap: var(--p-size-static-200);
    justify-content: space-between;
    background-color: var(--b-color-error-light);
    padding: var(--p-size-static-100) var(--p-size-static-200);
    border-radius: var(--s-size-radius-medium);
    line-height: var(--p-size-dynamic-300);
  }

  &__messages {
    display: flex;
    flex-direction: column;
    gap: var(--p-size-static-100);
    margin: 0 0 var(--p-size-static-100);
    &--inside {
      order: 2;
    }
    &--below {
      order: 4;
      #{$quantity}__help-msg {
        margin-top: 0;
      }
      #{$quantity}__error-msg {
        margin: var(--p-size-static-100) 0 0;
      }
    }
  }
}